<img *ngIf="urlIcon" src="{{urlIcon}}">